// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3NtLa","title":"Info_title__12IhZ","selects":"Info_selects__2X4Yx","requiredAsterisk":"Info_requiredAsterisk__3Yoeh"};